import { AxiosRequestConfig } from 'axios';
import { emeraldRequest } from 'src/common/api/emerald-request';
import { ForceSignInDto } from 'src/common/interfaces/dtos/IForceSignIn';
import { ILoginUser } from 'src/common/interfaces/dtos/ILoginUser';
import { EmeraldRequestParams } from 'src/common/interfaces/requests/EmeraldRequestParams';

export const forceSignInPost = async (creds: ForceSignInDto): Promise<ILoginUser> => {
  const axiosConfig: AxiosRequestConfig = {
    method: 'POST',
    url: '/auth/force-sign-in',
    data: creds,
  };

  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoadingComponent: false,
    showLoggingInfo: false,
  };

  return await emeraldRequest<ILoginUser>(emeraldRequestParams);
};
